import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/internal/operators';
import {SweetAlert2Mixins} from '../../../../_shared/sweetalert2-mixins/sweetalert2-mixins';
import {SystemService} from '../../../../_services/system.service';
import {TranslateService} from '@ngx-translate/core';
import {Helpers} from "../../../../helpers";

@Component({
  selector: 'app-register-employee-step-form',
  templateUrl: './register-employee-step-form.component.html',
  styleUrls: ['./register-employee-step-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterEmployeeStepFormComponent implements OnInit, OnChanges {

  registerForm: FormGroup;
  regions: any[];
  regionsInput$ = new Subject<string>();
  showLoader = false;

  currentStep = 0;
  steps = [
    {state: 'active'},
    {state: 'todo'},
    {state: 'todo'},
  ];

  inputDisabled = false;

  @ViewChild('cvInput') cvInput: ElementRef;
  @Input() errors: any;
  @Output() errorsChange = new EventEmitter<any>();
  @Output() submitted = new EventEmitter();
  @Output() closed = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private _systemService: SystemService,
    private _translateService: TranslateService,
    private ref: ChangeDetectorRef
  ) {
  }

  get step1Valid(): boolean {
    return this.registerForm.get('first_name').valid
      && this.registerForm.get('last_name').valid
      && this.registerForm.get('email').valid
      && this.registerForm.get('mobile').valid
      && this.registerForm.get('password').valid;
  }

  get step2Valid(): boolean {
    return this.registerForm.get('job_function').valid
      && this.registerForm.get('region_id').valid;
  }

  previousStep(): void {
    this.steps[this.currentStep].state = 'todo';
    this.steps[this.currentStep - 1].state = 'active';
    this.currentStep--;
  }

  nextStep(): void {
    this.steps[this.currentStep].state = 'complete';
    this.steps[this.currentStep + 1].state = 'active';
    this.currentStep++;
  }

  ngOnInit() {
    this.initForm();
    this.subscribeToRegionsSearch();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.errors) {
      this.showLoader = false;
      if (this.errors && this.errors.message && this.errors.message.email) {
        this.steps = [
          {state: 'active'},
          {state: 'todo'},
          {state: 'todo'},
        ];
        this.currentStep = 0;
        this.ref.detectChanges();
        this.registerForm.get('email').setErrors({'backend': true})
      }
    }
  }

  close(): void {
    this.closed.emit();
  }

  fileInputClicked(): void {
    this.cvInput.nativeElement.click();
  }

  initForm() {
    this.registerForm = this.fb.group({
      job_function: new FormControl('', Validators.required),
      region_id: new FormControl(undefined, Validators.required),
      file: new FormControl(''),
      filename: new FormControl(''),
      first_name: new FormControl('', [Validators.required, Validators.maxLength(60)]),
      mobile: new FormControl('', [Validators.minLength(9), Validators.maxLength(30)]),
      last_name: new FormControl('', [Validators.required, Validators.maxLength(60)]),
      email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(255)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      terms: new FormControl(false, Validators.requiredTrue)
    });
  }

  addFile = (fileInput) => {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.addEventListener('load', () => {
        this.registerForm.controls.file.patchValue((reader.result as string).split(',')[1]);
      }, false);

      this.registerForm.controls.filename.patchValue(fileInput.target.files[0].name);

      if (fileInput) {
        reader.readAsDataURL(fileInput.target.files[0]);
      }
    }
  }

  subscribeToRegionsSearch = () => {
    this.regionsInput$.pipe(
      debounceTime(150),
      distinctUntilChanged()
    ).subscribe(query => {
      if (query) {
        this._systemService.getLocations(query).subscribe((resp) => {
          this.regions = resp.result;
        }, error => {
          console.log(error);
          SweetAlert2Mixins.toast.error.fire(this._translateService.instant('sweetalert.error'));
        });
      }
    });
  }

  submit() {
    this.showLoader = true;
    this.submitted.emit(this.registerForm.getRawValue());
  }

}
